import apiClient from "@/util/apiClient";
interface LogData {
  systemkbn: string;
  userId: string;
  agCode: string;
  actionTime: string;
  operationType: string;
  pseudoAgCode: string;
  pseudoUserId: string;
  fromScreenName: string;
  toScreenName: string;
  controlName: string;
  actionDetail: string;
  genericField1: string;
  genericField2: string;
  genericField3: string;
  currentUrl: string;
}

const logService = {
  async sendLog(data: LogData): Promise<void> {
    try {
      //debag用
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log(data);
      }

      await apiClient.post("/api/log", data);

      //debag用
      if (process.env.VUE_APP_DEBUG === "true") {
        console.log("ログがサーバーに送信されました。");
      }
    } catch (error) {
      if (process.env.VUE_APP_DEBUG === "true") {
        console.error("ログの送信に失敗しました。", error);
      }
    }
  },
};

export default logService;
